import { render, staticRenderFns } from "./firmwareDetail.vue?vue&type=template&id=6889a004&scoped=true&"
import script from "./firmwareDetail.vue?vue&type=script&lang=js&"
export * from "./firmwareDetail.vue?vue&type=script&lang=js&"
import style0 from "./firmwareDetail.vue?vue&type=style&index=0&id=6889a004&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6889a004",
  null
  
)

export default component.exports